import { orderItemProductHasAccessEventZodObject } from "@@/shared/orders/order-events/events/order-item-events/order-item-product-has-access.event";
import z from "zod";
import { orderItemBookableTimeUpdatedEventZodObject } from "./order-item-bookable-time-updated.event";
import { orderItemStatusSetEventZodObject } from "./order-item-status-set.event";

const orderItemEventZodDiscriminatedUnion = z.discriminatedUnion("type", [
    // orderItemAddedEventZodObject,
    // orderItemRemovedEventZodObject,
    orderItemStatusSetEventZodObject,
    // orderItemBookableTimeChangedEventZodObject,
    orderItemBookableTimeUpdatedEventZodObject,
    orderItemProductHasAccessEventZodObject,
]);
type OrderItemEvent = z.infer<typeof orderItemEventZodDiscriminatedUnion>;
const orderItemEventZodSchema =
    orderItemEventZodDiscriminatedUnion as z.ZodSchema<OrderItemEvent>;

// const isOrderItemEvent = (event: any): event is OrderChangedEvent => {
//     return !!event && event._type === "ORDER_EVENT" && [] event.type === "ORDER_CHANGED";
// };

export { orderItemEventZodDiscriminatedUnion, orderItemEventZodSchema };
export type { OrderItemEvent };
